"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Activation = void 0;
class Activation {
    constructor(options) {
        this.onIsActiveChanged = options.onIsActiveChanged;
        this.isActive = false;
        this.timers = [];
    }
    activate() {
        this.isActive = true;
        this.onIsActiveChanged({ isActive: true });
    }
    deactivate() {
        this.isActive = false;
        this.onIsActiveChanged({ isActive: false });
        this.clearTimers();
    }
    toggleActivation() {
        if (this.isActive) {
            this.deactivate();
        }
        else {
            this.activate();
        }
    }
    clearTimers() {
        const { timers } = this;
        while (timers.length) {
            const timer = timers.pop();
            if (timer === null || timer === void 0 ? void 0 : timer.id) {
                // @ts-expect-error
                clearTimeout(timer.id);
            }
        }
    }
    clearTimer(timerName) {
        this.timers.forEach((timer) => {
            if (timer.name === timerName) {
                // @ts-expect-error
                clearTimeout(timer.id);
            }
        });
    }
}
exports.Activation = Activation;
//# sourceMappingURL=Activation.js.map